(function() {
    /** @ngInject */
    function messagesctrl($scope, $http) {
        $scope.messageToRestaurant = '';
        var messages= _.has($scope.booking,'messages') ? $scope.booking.messages : [];
        $scope.sendMessageToRestaurant = function(){
            return $http.post("/reservation/api/booking/writeMessage", {
                bookingCode : $scope.booking.short_code,  message : $scope.messageToRestaurant, 'hash' : hash
            }).success(function(response){
                if(response.success !== true){
                    alert(response.errors);
                }else{
                    $scope.messageToRestaurant = '';
                    messages = response.messages;
                    scrollToend();
                }
            });
        };
        $scope.getMessages = function(){
            return messages;
        };
        scrollToend();
        function scrollToend(){
            window.setTimeout(function(){
                var _messages = document.querySelector('#message-queue');
                if(_messages)
                    _messages.scrollTop = _messages.scrollHeight+10;
            },300);
        }

    }
    angular.module("Waiteraid").controller("messagesCtrl", messagesctrl);
})();
